// Mute preference only (non-sensitive) — localStorage is appropriate.
const KEY = "ccs-muted";
let ctx;

export const isMuted = () => localStorage.getItem(KEY) === "1";
export const setMuted = (m) => localStorage.setItem(KEY, m ? "1" : "0");

export const audio = () => {
  if (isMuted()) return null;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
  } catch {
    return null;
  }
};

const tone = (ac, freq, start, dur, type = "triangle", gain = 0.18) => {
  const o = ac.createOscillator();
  const g = ac.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, ac.currentTime + start);
  g.gain.setValueAtTime(0, ac.currentTime + start);
  g.gain.linearRampToValueAtTime(gain, ac.currentTime + start + 0.015);
  g.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + start + dur);
  o.connect(g).connect(ac.destination);
  o.start(ac.currentTime + start);
  o.stop(ac.currentTime + start + dur + 0.05);
};

// Bright two-note "ding-ding" sparkle for a sticker.
export function playSticker() {
  const ac = audio();
  if (!ac) return;
  tone(ac, 880, 0, 0.35);
  tone(ac, 1318.5, 0.12, 0.45);
  tone(ac, 1760, 0.24, 0.6, "sine", 0.1);
}

// Soft two-note horse whinny for Huey (gliding pitch + gentle vibrato).
export function playNeigh() {
  const ac = audio();
  if (!ac) return;
  const t0 = ac.currentTime;
  const o = ac.createOscillator();
  const g = ac.createGain();
  const lfo = ac.createOscillator();
  const lfoGain = ac.createGain();
  o.type = "triangle";
  o.frequency.setValueAtTime(620, t0);
  o.frequency.exponentialRampToValueAtTime(880, t0 + 0.12);
  o.frequency.exponentialRampToValueAtTime(520, t0 + 0.42);
  o.frequency.exponentialRampToValueAtTime(680, t0 + 0.5);
  o.frequency.exponentialRampToValueAtTime(420, t0 + 0.8);
  lfo.type = "sine";
  lfo.frequency.value = 11;
  lfoGain.gain.value = 22;
  lfo.connect(lfoGain).connect(o.frequency);
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(0.12, t0 + 0.04);
  g.gain.setValueAtTime(0.12, t0 + 0.4);
  g.gain.linearRampToValueAtTime(0.08, t0 + 0.5);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.85);
  o.connect(g).connect(ac.destination);
  o.start(t0); lfo.start(t0);
  o.stop(t0 + 0.9); lfo.stop(t0 + 0.9);
}

// Rising fanfare for a milestone badge.
export function playMilestone() {
  const ac = audio();
  if (!ac) return;
  [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => tone(ac, f, i * 0.13, 0.4, "square", 0.08));
  [1046.5, 1318.5, 1567.98].forEach((f, i) => tone(ac, f, 0.6 + i * 0.1, 0.9, "triangle", 0.14));
  tone(ac, 2093, 0.9, 1.2, "sine", 0.08);
}
